import { sendMessage } from './sendMessage';
import { ERequestApiStatus, EWsClientEventType } from '../../types/appState';
import { TThunkAction } from '../../types/redux/thunk';
import { retrySendFileMessage } from '../sendFileMessage/retrySendFileMessage';
import { sendOfferMessage } from '../sendOfferMessage';

export const retrySendMessage =
  (currentChatId: string): TThunkAction<void> =>
  (dispatch, getState, { logger }) => {
    const {
      openedChats,
      socket: { clientEvents },
      chatWindow,
    } = getState();

    const currentChat = openedChats[currentChatId];

    if (!currentChat) {
      logger.error(`Couldn't retry messages, chat "${currentChatId}" not found`);

      return;
    }

    const events = Array.from(clientEvents.entries());

    events.forEach(([key, { status, type }]) => {
      if (status !== ERequestApiStatus.Failed || type !== EWsClientEventType.Message) {
        return;
      }

      const messageItem = chatWindow.messagesMap.get(key);

      if (!messageItem || messageItem.message.chatId !== currentChatId) {
        return;
      }

      const pendingFiles = currentChat.pendingFiles?.[key];

      if (messageItem.message.message.offers?.length) {
        clientEvents.delete(key);

        dispatch(
          sendOfferMessage({ chatId: currentChatId, offer: messageItem.message.message.offers[0], messageId: key }),
        );

        return;
      }

      // Сообщение с одним фото-файлом в начальной реализации
      if (pendingFiles?.blobFiles?.length || pendingFiles?.uploadedFiles?.length) {
        clientEvents.delete(key);

        dispatch(retrySendFileMessage({ chatId: currentChatId, messageId: key, pendingFiles }));

        return;
      }

      clientEvents.delete(key);
      dispatch(sendMessage(messageItem.message.message.message, currentChatId, key));
    });
  };
